module.exports = __webpack_public_path__ + "2cfbd8fed94c1e8cd2a5ce074063f6d8.png";